import React, { useState, useEffect ,useRef, useCallback } from 'react';
import  ScopeList  from '../components/scope-list-view';
import { useDispatch,  useSelector } from 'react-redux';
import {
  scopeManagementIsLoading,
  scopeManagementScopes,
  scopeManagementScopesRequestGet,
  scopeManagementPost,
  scopeManagementScopePatch,
  scopeManagementScopeApproversPut,
  scopeManagementScopeApproversGet,
  getApproversIsLoading,
  scopeManagementScopeApproversDelete
} from 'modules/scope-management-module';
import { socialServiceRequestGet } from 'modules/role-management-module';
import { getAPIError, stopEvent } from 'lib/utility-functions';
import { uiShowToastrMessage } from 'modules/ui-module';
import { isEmpty, isEqual , sortBy, cloneDeep } from 'lodash';
import { meLocale } from 'modules/me-module';

const descriptionFields = [
  "description_EN",
  "description_DE",
  "description_ES",
  "description_FR",
  "description_IT",
  "description_JA",
  "description_KO",
  "description_PT",
  "description_ZH"
];

export const ScopeListContainer = () => {
  const getValuesFromStore = (state) =>{
  return {
    isloading: scopeManagementIsLoading(state),
    scopes: scopeManagementScopes(state),
    approversIsLoading: getApproversIsLoading(state),
    meLocale: meLocale(state),
   };
};
  const dispatch = useDispatch();
  const originalState = { 
    id: '',
    approvers: [],
    active: true,
    public: false,
    description: {
      en: "",
      de: "",
      es: "",
      fr: "",
      it: "",
      ja: "",
      ko: "",
      pt: "",
      zh: ""
    } 
  };
  const externalProps = useSelector(getValuesFromStore);
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  const [showAddRoleDialog, setShowAddRoleDialog] = useState(false);
  const [openEditRoleDialog,setOpenEditRoleDialog] = useState(false);
  const [scope, setScope] = useState(originalState);
  const [errors, setErrors] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [ownersList, setOwnersList] = useState([]);
  const [personIconClicked, setPersonIconClicked] = useState(false);
  const [autoCompletelist , setAutoCompletelist] = useState([]);
  const autoCompleteRef = useRef(null);
  const [textEmail,setEmail] = useState('');
  const [scopeList, setScopeList] = useState(externalProps.scopes);
  const [sortDirection, setSortDirection] = useState(null);
  const mounted = useRef();


  const onClickAddRole = () => {
    setScope(originalState);
    setShowAddRoleDialog(true);
  };

  const getApproversList = (id) => {
    dispatch(scopeManagementScopeApproversGet(id)).
    then(
      (response) => {
        setOwnersList(response.payload.map((item) => item.email));
        return response.payload.map((item) => item.email);
      }
    );
  };

  const editOnClick = (id) => {
    dispatch(scopeManagementScopeApproversGet(id)).
      then((response) => {
        let openedScope = externalProps.scopes.find((data) => data.id === id);
        const approversEmails = response.payload.map((item) => item.email);
        setOwnersList(approversEmails);
        const scopeCopy = cloneDeep(openedScope);
        if(!scopeCopy?.description ){
          scopeCopy.description = { ...originalState.description };
        }
        const updatedRole = {
          ...scopeCopy,
          approvers: approversEmails || []
        };
        setScope(updatedRole);
        setOpenEditRoleDialog(true);
      });
  };

  const closeEditModel = () =>{
    setOpenEditRoleDialog(false);
    setShowAddRoleDialog(false);
    setScope(originalState);
    setEnableSubmit(false);
    setOwnersList([]);
    setAutoCompletelist([]);
    if(autoCompleteRef.current) {
      autoCompleteRef.current.value = '';
      autoCompleteRef.current.clear();
    }
  };

  const personIconClick = (id) => {
    setPersonIconClicked(true);
    getApproversList(id);
  };

  const onSort = () => {
    const columnKey = 'id';
    const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortDirection(newSortDirection);

    const sortedData = [...externalProps.scopes].sort((a, b) => {
      return newSortDirection === 'asc'
      ? a[columnKey].localeCompare(b[columnKey])
      : b[columnKey].localeCompare(a[columnKey]);
    });
    setScopeList(sortedData);
  };

  const displayToastrMessage = (toastrType, toastrMessageId, toastrParams = null) => {
    dispatch(uiShowToastrMessage(toastrType, toastrMessageId, toastrParams));
  };

  const handleXHRResult = (success, messageId, toastrParams = null) => {
    const toastrType = success ? 'success' : 'error';
    displayToastrMessage(toastrType, messageId);
  };

  const validateUserInput = (field, value) => {
    let errorText = '';
    const foundErrors = { ...errors };

    if (foundErrors[field]) {
      delete foundErrors[field];
    }
    if(field === 'id'){
      const feildValue = value ;
      const alreadyPresentName = externalProps.scopes.some(scope => scope.id.trim() == feildValue.trim());
      if (alreadyPresentName) {
        errorText = 'role-management.role.already.exists';
      }
    }
    if (field=== 'id' && !errorText.length && value.length > 0 && value.trim().length === 0 ) {
      errorText = 'role-management.role.id.invalid';
    }
    if(field === 'groupId' && !['collab', 'support', 'org', 'admin', 'profile', 'g2c'].includes(value)){
      errorText = 'scope-management.input-field-groupid.helper-text';
    }
    if (descriptionFields.includes(field) && value.length > 500) {
      errorText = 'client-edit.validation.description-exceeds-max-length';
    }
    if(field === 'approvers' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)){
      errorText = 'role-management.role.owner.invalid';
    }
    if (errorText.length) {
      foundErrors[field] = errorText;
      setEnableSubmit(false);
    }
    setErrors(foundErrors);
    return !errorText.length;
  };

  const updateScopeState = (e) => {
    stopEvent(e);
    setErrors({});

    const field = e.target && e.target.id.split('-')[0];
    const value = e.target && e.target.value;

    setScope(prevScope => {
      const foundScope = { ...prevScope };

      if (field === 'active') {
        foundScope[field] = e.target.checked;
      }
      else if (field === 'public') {
        foundScope[field] = e.target.checked;
      }
      else if(field === 'id' && validateUserInput(field, value)){
        foundScope[field] = value;
      }
      else if(field === 'groupId' && validateUserInput(field, value)){
        foundScope[field] = value;
      }
      else if(field === 'approvers'){
        const text = e.detail.value;
        if(text && text.length > 0){
          setEmail(text);
          dispatch(socialServiceRequestGet(text)).
          then(
            (response) => {
              setAutoCompletelist(response.payload?.users?.map((item) => item.email));
            });
        }
        //handles if same email id used multiple times in the autocomplete
        foundScope[field] = !!ownersList.length ? [...new Set([...(e.detail?.selectedOptions || []).map(option => option.value)])] :
        [...new Set([...(foundScope[field] || []),...(e.detail?.selectedOptions || []).map(option => option.value)])];
      }
      else if (descriptionFields.includes(field) && validateUserInput(field, value)){
        const changedLocale = (field.split('_')[1])?.toLowerCase();
        // If description object is not defined then 
        if (!foundScope.description) {
          foundScope.description = {};
        }
        foundScope.description[changedLocale] = value;
      }
      return foundScope;
    });
    return true;
  };

  const onSubmit = async(e) => {
    stopEvent(e);
    let originalScope = (scope && scope.id) ? externalProps.scopes.find((data) => data.id === scope.id) : null;
    setEnableSubmit(false);
    if(openEditRoleDialog){
      setOpenEditRoleDialog(false);
      const newApprovers = scope.approvers?.filter((approver) => !ownersList.includes(approver.trim()));
      const deletedApprovers = ownersList.filter((approver) => !scope.approvers?.includes(approver.trim()));

      if(newApprovers && newApprovers.length > 0){
        for(const newApprover of  newApprovers){
          dispatch(scopeManagementScopeApproversPut(scope.id, newApprover,newApprover)).
          then(
            () => {
              handleXHRResult(true, 'scope-management.scope.owners.add.success');
            },
            () => {
              handleXHRResult(false, 'role-management.role.owners.add.failed');
            });
          await sleep(1000);
          }
      }
      if(deletedApprovers && deletedApprovers.length > 0){
        for(const approver of  deletedApprovers){
          dispatch(scopeManagementScopeApproversDelete(scope.id, approver, approver)).then(
            () => {
              handleXHRResult(true, 'scope-management.scope.owners.delete.success');
            },
            (error) => {
              handleXHRResult(false, 'role-management.role.owners.delete.failed');
            });
          await sleep(1000);
        }
      }
      if((!!scope && !!originalScope) && 
        (scope.active !== originalScope.active ||
         scope.public !== originalScope.public ||
         scope.description?.en?.trim() !== originalScope.description?.en?.trim() ||
         scope.description?.de?.trim() !== originalScope.description?.de?.trim() ||
         scope.description?.es?.trim() !== originalScope.description?.es?.trim() || 
         scope.description?.fr?.trim() !== originalScope.description?.fr?.trim() || 
         scope.description?.it?.trim() !== originalScope.description?.it?.trim() ||
         scope.description?.ja?.trim() !== originalScope.description?.ja?.trim() ||
         scope.description?.ko?.trim() !== originalScope.description?.ko?.trim() ||
         scope.description?.pt?.trim() !== originalScope.description?.pt?.trim() || 
         scope.description?.zh?.trim() !== originalScope.description?.zh?.trim())){
        // Don't include approvers in patch - they're handled separately above
        const { approvers, ...dataToSave } = scope;
        dispatch(scopeManagementScopePatch(scope.id, dataToSave)).
          then(
            () => {
              handleXHRResult(true, 'scope-management.scope.edit.success');
              dispatch(scopeManagementScopesRequestGet());
            },
            () => {
              handleXHRResult(false, 'scope-management.scope.edit.failed');
            },
          );
      }
    }
    else{
      const approvers = scope.approvers;
      delete scope.approvers;
      dispatch(scopeManagementPost(scope))
        .then(
          async () => {
            handleXHRResult(true, 'scope-management.scope.create.success');
            dispatch(scopeManagementScopesRequestGet());
            setShowAddRoleDialog(false);
            if (approvers && approvers.length > 0) {
              for(const approver of approvers){
                dispatch(scopeManagementScopeApproversPut(scope?.id, approver,approver)).
                then(
                  () => {
                    setShowAddRoleDialog(false);
                  },
                  () => {
                    handleXHRResult(false, 'scope-management.scope.add.failed');
                    setShowAddRoleDialog(false);
                  });
                await sleep(1000);
              }
            }
          },
          () => {
            handleXHRResult(false, 'scope-management.scope.add.failed');
            setShowAddRoleDialog(false);
          },
        );
    }
    setScope(originalState);
    setOwnersList([]);
    setAutoCompletelist([]);
    if(autoCompleteRef.current) {
      autoCompleteRef.current.value = '';
      autoCompleteRef.current.clear();
    }
  };

  const onClickAddOwner = (e) => {
    stopEvent(e);
    if (textEmail && textEmail.trim() && validateUserInput('approvers', textEmail.trim())) {
      const foundRole = { ...scope };
      const currentApprovers = foundRole.approvers || [];
      if (!currentApprovers.includes(textEmail)) {
        foundRole.approvers = [...new Set([...currentApprovers, textEmail])];
        setScope(foundRole);
        if(autoCompleteRef.current) {
          autoCompleteRef.current.value = '';
          setEmail('');
        }
      }
    }
  };

  const popOverChange = () =>{
    if(personIconClicked){
      setPersonIconClicked(false);
      setOwnersList([]);
    }
  };

  const updateEditCTA = useCallback(async() => {
    let originalScope = (scope && scope.id) ? externalProps.scopes.find((data) => data.id === scope.id) : null;
    if(originalScope && !originalScope.description){
      originalScope.description = originalState.description;
    }
    if(showAddRoleDialog && isEmpty(errors) && scope.id){
      setEnableSubmit(true);
    }
    // For edit dialog
    else if(openEditRoleDialog && originalScope){
      if (((scope.active !== originalScope.active) || (scope.public !== originalScope.public) ||
        (!isEqual (scope.description, originalScope.description)) || !isEqual(sortBy(scope.approvers), sortBy(ownersList))) &&
      isEmpty(errors)) {
        setEnableSubmit(true);
      }
      else {
        setEnableSubmit(false);
      }
    }
    // Default case - disable submit
    else {
      setEnableSubmit(false);
    }
  },[scopeList, errors,externalProps.scopes,scope,ownersList,showAddRoleDialog,openEditRoleDialog]);

  useEffect(() => {
    if (!mounted.current) {
      dispatch(scopeManagementScopesRequestGet());
      mounted.current = true;
    }
    else {
      updateEditCTA();
    }
  }, [dispatch,updateEditCTA,openEditRoleDialog,ownersList]);

  return (
    <ScopeList
      isloading={externalProps?.isloading}
      getApproversIsLoading={externalProps?.approversIsLoading}
      onClickAddRole={onClickAddRole}
      showAddRoleDialog={showAddRoleDialog}
      scopes={scopeList.length > 0 ? scopeList : externalProps.scopes}
      editOnClick={editOnClick}
      openEditRoleDialog={openEditRoleDialog}
      closeEditModel={closeEditModel}
      onSubmit={onSubmit}
      onChange={updateScopeState}
      scope={scope}
      validateUserInput={validateUserInput}
      errors={errors}
      enableSubmit={enableSubmit}
      autocompleteList={autoCompletelist}
      personIconClick={personIconClick}
      ownersList={ownersList}
      personIconClicked={personIconClicked}
      popOverChange={popOverChange}
      autoCompleteRef={autoCompleteRef}
      onClickAddOwner={onClickAddOwner}
      onSort={onSort}
      sortDirection={sortDirection}
      meLocale={externalProps?.meLocale ? externalProps?.meLocale.split('_')[0] : 'en'}
      />
  );
};



export default ScopeListContainer;
